import React, { useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
  overflow: hidden;
`;

const loadScriptByURL = (id, url, callback) => {
  const isScriptExist = document.getElementById(id);

  if (!isScriptExist) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.onload = callback;
    document.body.appendChild(script);
  } else {
    callback();
  }
};

const CalendlyComponent = ({ url }) => {
  useEffect(() => {
    loadScriptByURL('calendly', `https://assets.calendly.com/assets/external/widget.js`, () => {
      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url,
        parentElement: document.getElementById('calendly-container'),
        prefill: {},
        utm: {}
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Wrapper id="calendly-container" />;
};

export default CalendlyComponent;
